import React, {  useEffect, useState,useRef,useContext  } from "react";


export default function Adyen_3ds(props) {
    

    const [formRedirect, setformRedirect] = useState(null);
    const [loaded, setLoaded] = useState(false);


    const formRef = useRef(null);

    useEffect(() => { 
        console.log("creo form",props)
        setformRedirect(formRed(props.action.url,props.action.data))
        setLoaded(true)
    },[])

    useEffect(() => {  
        console.log("invio")
        if (formRef.current && loaded) {
        setTimeout(()=>{
            formRef.current.submit(); // Trigger del submit del form
        },2000)
        
        }

    },[loaded]);


    
    
    function formRed(redirect_url,params){
     
        return (<form action={redirect_url} method="POST" ref={formRef}>
          {Object.entries(params).map(([key, value]) => {
            return (
            <input name={key} value={value} type="hidden"></input>
            )
          })
          }
         </form>)
      }

    return (
        <div className="all-container bg-light pianiAbbonamentoPage">
             {formRedirect}
        </div>
    )
   


}